import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { BrandingService } from '@core/services/branding.service';
import { EntitlementService } from '@core/services/entitlement.service';
import { ToastComponent } from '@shared/components/toast/toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent],
  template: `
    <router-outlet />
    <app-toast />
  `,
})
export class AppComponent implements OnInit {
  private readonly auth = inject(AuthService);
  private readonly branding = inject(BrandingService);
  private readonly entitlements = inject(EntitlementService);

  ngOnInit(): void {
    // Establish the correct theme + page title for the restored session:
    // school users (incl. impersonation) get their school's branding; a super
    // admin (and logged-out visitors) get the product default. The login page
    // separately re-themes as the school code is typed. The school's modules
    // (plan + add-ons) load alongside its branding.
    if (this.auth.isLoggedIn() && !this.auth.isSuperAdmin()) {
      void this.branding.loadFromAuth();
      void this.entitlements.load();
    } else {
      this.branding.resetToDefault();
    }
  }
}
